import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Loading spinner component for lazy loaded routes and data fetching
 */
export function LoadingSpinner({ message = 'Loading...', fullScreen = false }) {
  const containerProps = fullScreen
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'background.default',
        zIndex: 9999,
      }
    : {
        minHeight: '300px',
      };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      {...containerProps}
    >
      <CircularProgress size={60} />
      {message && (
        <Typography variant="body1" color="text.secondary" mt={2}>
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default LoadingSpinner;

